import "jquery-match-height";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function (e) {
  $("[data-mh-window-load]").matchHeight();
});

/*
 * For nested child elements
 * ----------------------------------------------- */
jQuery(window).on("load", function (e) {
  $(".row").each(function () {
    $(this).find(".nested").matchHeight();
  });
});

window.almOnLoad = function (alm) {
  jQuery(".link-container .col-sm-4").matchHeight({});
};

window.almComplete = function (alm) {
  jQuery(".link-container .col-sm-4").matchHeight({});
};

window.almDone = function () {
  console.log("ALL complite");
  setTimeout(function () {
    jQuery(".link-container .col-sm-4").matchHeight({});
  }, 750);
};
